 const isEmptyOrSpaces = (str:any) => {
    return !str || str.toString().trim() === '';
};

export default isEmptyOrSpaces;